module.exports = __webpack_public_path__ + "media/images/page/top/mvSp2-b31dfe1807a0bfe360f90b78243e94c8.jpg";